import { useMemo, useRef } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

export const useIntlDateTimeFormat = (options: Intl.DateTimeFormatOptions) => {
  const { i18n } = useTranslation();
  const optionsRef = useRef(options);

  const yearMonthFormatter = useMemo(
    () => new Intl.DateTimeFormat(i18n.language, optionsRef.current),
    [i18n.language, optionsRef],
  );

  return yearMonthFormatter;
};
